export const getLocale = (locale: string) => {
    return locale === "ua" ? "uk" : locale;
};
